<template>
  <div class="content content-fixed content-auth-alt" style="min-height: 85vh">
    <div class="container d-flex justify-content-center ht-100p">
      <div
        class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center"
      >
        <div class="wd-150 wd-sm-250 mg-b-30">
          <img src="/assets/img/img18.png" class="img-fluid" alt />
        </div>
        <h4 class="tx-20 tx-sm-24">Нууц үг сэргээх</h4>
        <p class="tx-color-03 mg-b-40">
          Нууц үг хамгийн багадаа 6 тэмдэгт байна
        </p>
        <!-- <p class="text-muted tx-color-03"></p> -->
        <!-- <div class="wd-100p d-flex flex-column flex-sm-row mg-b-40">
            <input v-model="userName" type="text" class="form-control wd-sm-250 flex-fill" placeholder="Бүртгэлтэй и-мэйл хаягаа оруулна уу">
            <button class="btn btn-brand-02 mg-sm-l-10 mg-t-10 mg-sm-t-0" @click="send">Илгээх</button>
        </div>-->
        <div v-if="recoverReady">
          <div class="form-group">
            <label>Нууц үг</label>
            <input
              v-model="form.password"
              type="password"
              class="form-control wd-sm-250 flex-fill"
              placeholder="Нууц үг"
            />
          </div>
          <div class="form-group">
            <label>Нууц үг давт</label>
            <input
              v-model="form.rePassword"
              type="password"
              class="form-control wd-sm-250 flex-fill"
              placeholder="Нууц үг давт"
            />
          </div>

          <button
            class="btn btn-brand-02 mg-sm-l-10 mg-t-10 mg-sm-t-0"
            @click="send"
          >
            Илгээх
          </button>
        </div>
        <!-- <span
          class="tx-12 tx-color-03"
        >жич: Нууц үг сэргээх холбоос и-мэйл таны INBOX folder-т очоогүй бол SPAM folder-оо шалгана уу.</span>
        <span class="tx-12 tx-color-03">
          Бүртгэлээ санаж буй бол
          <router-link to="/login">Нэвтрэх</router-link> 
        </span>-->
      </div>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";
import { localRead } from "@/libs/util";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      recoverReady: false,
      form: {
        password: "",
        rePassword: ""
      }
    };
  },
  mounted() {
    //HasRecoverKey({ pk: this.$route.params.pk })

    request({
      api: { method: "get", url: "user/HasRecoverKey" },
      params: {
        pk: this.$route.params.pk
      },
      store: this.$store
    }).then(res => {
      if (res != false) {
        this.recoverReady = true;
      } else {
        this.$router.push({ name: "login" });
      }
    });
  },
  methods: {
    ...mapActions(["handleLoading"]),
    send() {
      var canSend = false;
      canSend = this.form.password.length >= 6;
      canSend = this.form.password == this.form.rePassword;
      if (canSend) {
        this.handleLoading({ isLoading: true });

        request({
          api: { method: "POST", url: "user/Recover" },
          params: {
            pk: this.$route.params.pk,
            password: this.form.password
          },
          store: this.$store
        }).then(res => {
          this.handleLoading({ isLoading: false });
          if (res != false) {
            Notification.success({
              message: "Нууц үг амжилттай сэргээлээ.",
              title: "Амжилттай",
              duration: 30000,
              type: "success",
              position: "top-right",
              offset: 50
            });
            this.$router.push({ name: "login" });
          }
        });
      } else {
        Notification.success({
          message:
            "Нууц үг хамгийн багадаа 6 тэмдэгттэй байна. Мөн нууц үг нууц үг давт 2 талбар ижил байна.",
          title: "Амжилтгүй",
          duration: 30000,
          type: "warning",
          position: "top-right",
          offset: 50
        });
      }
    }
  }
};
</script>
